import React, { Children } from 'react';
import PropTypes from 'prop-types';

import { Text, Paragraph } from 'components/core/Typography';

export default function ProsCons({ name, list }) {
	return (
		<div className="pros-cons-section">
			<Paragraph size="small">
				{name}
			</Paragraph>
			<ul className="pros-cons-list">
				{list.length ? (
					Children.toArray(list.map((item) => (
						<>
							{
							item.name != "Good Value Agg" && item.name != "Good Service Agg" && item.name != "CleanAgg" && <li>
							<Text className="pros-cons-item">
								{item.name} <span className="review-count">({item.reviewCount})</span>
							</Text>
						</li>
							}
						</>
					)))
				) : (
					<li>
						<Text>
							N/A
						</Text>
					</li>
				)}
			</ul>
		</div>
	);
}

ProsCons.propTypes = {
	name: PropTypes.string.isRequired,
	list: PropTypes.arrayOf(
		PropTypes.shape({
			name: PropTypes.string,
			reviewCount: PropTypes.number
		}),
	)
};

ProsCons.defaultProps = {
	list: []
};
